import { ForecastDataEntryPage } from "../../pages/production/forecast-data-entry/ForecastDataEntryPage";
import { MillSetupPage } from "../../pages/production/mill-setup";
import { MillSetupSheetPage } from "../../pages/production/mill-setup-sheet";
import { NextCampaignsPage } from "../../pages/production/next-campaigns/NextCampaignsPage";
import { PurchaseOrdersPage } from "../../pages/production/purchase-orders/PurchaseOrdersPage";
import { RollsCartridgePage } from "../../pages/production/rolls-cartridge/RollsCartridgePage";
import { RollsReceivedPage } from "../../pages/production/rolls-received/RollsReceivedPage";
import { Navigate } from "react-router-dom";
import { StraightenerTrendDisplayPage } from "../../pages/production/straightener-trend-display";
import { TrendDisplayPage } from "../../pages/production/trend-display/TrendDisplayPage";
import { OperationsTimelinePage } from "../../pages/production/operations-timeline/OperationsTimelinePage";

export const routeMillSetup = "/production/mill-setup";
export const routeOperationsTimeline = "/production/operations-timeline";
export const routeMillSetupSheet = "/production/mill-setup-sheet";
export const routeNextCampaigns = "/production/next-campaigns";
export const routePurchaseOrders = "/production/purchase-orders";
export const routeRollsCartridge = "/production/rolls-cartridge";
export const routeRollsReceived = "/production/rolls-received";
export const routeTrendDisplay = "/production/trend-display";
export const routeForecastDataEntry = "/production/forecast-data-entry";
// Straightener Recipes lives in Configuration; the old URL redirects there so
// bookmarks keep working.
export const routeStraightenerRecipes = "/configuration/straightener-recipes";
const legacyRouteStraightenerRecipes = "/production/straightener-recipes";
export const routeStraightenerTrendDisplay =
	"/production/straightener-trend-display";

export const productionRoutes = [
	{
		path: routeOperationsTimeline,
		element: <OperationsTimelinePage />,
	},
	{
		path: routeMillSetup,
		element: <MillSetupPage />,
	},
	{
		path: routeMillSetupSheet,
		element: <MillSetupSheetPage />,
	},
	{
		path: routeNextCampaigns,
		element: <NextCampaignsPage />,
	},
	{
		path: routePurchaseOrders,
		element: <PurchaseOrdersPage />,
	},
	{
		path: routeRollsCartridge,
		element: <RollsCartridgePage />,
	},
	{
		path: routeRollsReceived,
		element: <RollsReceivedPage />,
	},
	{
		path: routeTrendDisplay,
		element: <TrendDisplayPage />,
	},
	{
		path: routeStraightenerTrendDisplay,
		element: <StraightenerTrendDisplayPage />,
	},
	{
		path: legacyRouteStraightenerRecipes,
		element: <Navigate to={routeStraightenerRecipes} replace />,
	},
	{
		path: routeForecastDataEntry,
		element: <ForecastDataEntryPage />,
	},
	{
		path: `${routeForecastDataEntry}/:year`,
		element: <ForecastDataEntryPage />,
	},
];
